import React from "react";

import {
  FormControl,
  Select,
  OutlinedInput,
  Box,
  Chip,
  MenuItem,
} from "@mui/material";

// Example: BOOKING_CONTACT -> Booking Contact
const updateTextForDisplay = (text: string) => {
  return text
    .toLowerCase()
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

type SelectionDropdownProps = {
  setSelected: React.Dispatch<React.SetStateAction<string[]>>;
  selected: string[];
  options: string[];
  selectId: string;
};

function SelectionDropdown(props: SelectionDropdownProps) {
  const { setSelected, selected, options, selectId } = props;

  const handleChange = (event) => {
    const { value } = event.target;
    setSelected(value);
  };

  return (
    <FormControl sx={{ m: 1, width: "100%" }}>
      <Select
        disabled // v0 we are not allowing user to edit
        id={selectId}
        multiple
        value={selected}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={updateTextForDisplay(value)} />
            ))}
          </Box>
        )}
        sx={{
          "& .MuiSelect-select": {
            padding: "10px",
          },
        }}
      >
        {options.map((name) => (
          <MenuItem key={name} value={name}>
            {updateTextForDisplay(name)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectionDropdown;
